import React from "react";
import { useI18n } from "@/i18n/I18nProvider";
import { ListOrdered } from "lucide-react";

export default function AtlasHowItWorks() {
  const { t, messages } = useI18n();
  const steps = messages?.howItWorks?.steps || [];
  return (
    <section
      id="como-funciona"
      data-testid="atlas-howitworks"
      className="py-16 lg:py-24 bg-white"
    >
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-2 text-[#6B46C1] uppercase tracking-[0.18em] text-xs font-bold">
          <ListOrdered size={14} />
          <span>{t("howItWorks.badge")}</span>
        </div>
        <h2
          data-testid="howitworks-title"
          className="mt-4 font-display text-3xl sm:text-4xl lg:text-[44px] leading-tight font-extrabold text-slate-900"
        >
          {t("howItWorks.titleA")}{" "}
          <span className="text-[#6B46C1]">{t("howItWorks.titleB")}</span>
        </h2>
        <p className="mt-3 text-slate-600 text-base sm:text-lg max-w-2xl">
          {t("howItWorks.subtitle")}
        </p>

        <div className="mt-10 overflow-hidden rounded-2xl ring-1 ring-slate-200 shadow-sm">
          <table
            data-testid="howitworks-table"
            className="w-full text-left border-collapse"
          >
            <thead className="bg-slate-900 text-white">
              <tr>
                <th className="px-4 sm:px-6 py-4 text-xs sm:text-sm font-semibold uppercase tracking-wider w-20">
                  {t("howItWorks.colStep")}
                </th>
                <th className="px-4 sm:px-6 py-4 text-xs sm:text-sm font-semibold uppercase tracking-wider w-1/3">
                  {t("howItWorks.colAction")}
                </th>
                <th className="px-4 sm:px-6 py-4 text-xs sm:text-sm font-semibold uppercase tracking-wider">
                  {t("howItWorks.colDetail")}
                </th>
              </tr>
            </thead>
            <tbody>
              {steps.map((s, i) => (
                <tr
                  key={i}
                  data-testid={`howitworks-row-${i}`}
                  className={`${
                    i % 2 === 0 ? "bg-white" : "bg-slate-50/70"
                  } transition-colors hover:bg-[#6B46C1]/[0.06] border-t border-slate-200`}
                >
                  <td className="px-4 sm:px-6 py-4 align-top">
                    <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-[#6B46C1] text-white text-sm font-bold">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                  </td>
                  <td className="px-4 sm:px-6 py-4 align-top text-slate-900 font-semibold text-[15px] sm:text-base">
                    {s.action}
                  </td>
                  <td className="px-4 sm:px-6 py-4 align-top text-slate-600 text-sm sm:text-[15px] leading-relaxed">
                    {s.detail}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
